<ejs-dialog [isModal]="true" #editUserDialog [visible]="false" [width]="'45%'" [showCloseIcon]="true"
    (close)="onDialogClose($event)" zIndex="1000">
    <div id="edit-user">
        <div id="dates">
            <div fxLayout="row" fxLayoutGap="32px" fxLayout.xs="column" fxLayoutAlign="space-evenly center"
                [style.marginTop.rem]="'1'">
                <!-- START Date -->
                <mat-form-field color="accent">
                    <mat-label>Start Date(expected)</mat-label>
                    <input matInput [matDatepicker]="startDatePicker" [formControl]="expectedStartDate"
                        (dateChange)="startDateMethod($event)" readonly required [placeholder]="expectedStartDatePH"
                        (click)="startDatePicker.open(); expectedStartDate.markAsUntouched();">
                    <mat-datepicker-toggle color="accent" matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>

                <!-- END Date -->
                <div fxLayout="column">
                    <mat-form-field color="accent">
                        <mat-label>End Date(expected)</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" [formControl]="expectedEndDate"
                            (dateChange)="endDateMethod($event)" readonly required [placeholder]="expectedEndDatePH"
                            (click)="endDatePicker.open(); expectedEndDate.markAsUntouched();">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="!isValid" style="color: red; margin-top: -1.5em; height: .5em;" [style.width]="'10em'">
                        <span style="font-size: xx-small;"><b>End Date</b> is not valid.</span>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="32px" fxLayout.xs="column" fxLayoutAlign="space-evenly center"
                [style.marginTop.rem]="'1'">
                <mat-form-field>
                    <mat-label>Advisor</mat-label>
                    <mat-select [formControl]="advisorFromControl">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let option of advisorOptions" [value]="option.value">{{option.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <ng-template #footerTemplate>
        <button id="cancelButton" mat-flat-button data-ripple="true" (click)="closeKBFromDialog($event)">
            Cancel
        </button>
        <button id="sendButton" type="submit" mat-flat-button color="accent" (click)="submitFormData()">
            Done
        </button>
    </ng-template>
</ejs-dialog>